module.exports = __webpack_public_path__ + "img/Magnification_Poster_OpenFull.33860eb6.png";